import { pxToRem, createStyleFunction } from 'utils/ui';
// TO DO: Look into how this is different from `utils/ui/getGlobalThemeValue`
// and whether they should be unified or renamed for clarity
function getGlobalThemeValue(key) {
  return function (value, theme) {
    var _theme$globals, _theme$globals$key;
    var themeValue = ((_theme$globals = theme.globals) === null || _theme$globals === void 0 ? void 0 : (_theme$globals$key = _theme$globals[key]) === null || _theme$globals$key === void 0 ? void 0 : _theme$globals$key[value]) || value;
    if (typeof themeValue === 'function') {
      return themeValue(theme);
    }
    if (!isNaN(themeValue)) {
      return pxToRem(themeValue);
    }
    return themeValue;
  };
}
var getBorderValue = getGlobalThemeValue('borderStyles');
var getBoxShadowValue = getGlobalThemeValue('shadowStyles');
function getBorderRadiusValue(value, theme) {
  if (value === 'circular') {
    return '10rem';
  }
  return getGlobalThemeValue('borderRadius')(value, theme);
}
export var borderPropsDef = [{
  styleProp: 'border',
  getValue: getBorderValue
}, {
  styleProp: 'borderTop',
  getValue: getBorderValue
}, {
  styleProp: 'borderRight',
  getValue: getBorderValue
}, {
  styleProp: 'borderBottom',
  getValue: getBorderValue
}, {
  styleProp: 'borderLeft',
  getValue: getBorderValue
}, {
  styleProp: 'borderRadius',
  getValue: getBorderRadiusValue
}, {
  styleProp: 'borderTopRadius',
  properties: ['borderTopLeftRadius', 'borderTopRightRadius'],
  getValue: getBorderRadiusValue
}, {
  styleProp: 'borderRightRadius',
  properties: ['borderTopRightRadius', 'borderBottomRightRadius'],
  getValue: getBorderRadiusValue
}, {
  styleProp: 'borderBottomRadius',
  properties: ['borderBottomLeftRadius', 'borderBottomRightRadius'],
  getValue: getBorderRadiusValue
}, {
  styleProp: 'borderLeftRadius',
  properties: ['borderTopLeftRadius', 'borderBottomLeftRadius'],
  getValue: getBorderRadiusValue
}, {
  styleProp: 'borderTopLeftRadius',
  getValue: getBorderRadiusValue
}, {
  styleProp: 'borderTopRightRadius',
  getValue: getBorderRadiusValue
}, {
  styleProp: 'borderBottomRightRadius',
  getValue: getBorderRadiusValue
}, {
  styleProp: 'borderBottomLeftRadius',
  getValue: getBorderRadiusValue
}, {
  styleProp: 'boxShadow',
  getValue: getBoxShadowValue
}, {
  styleProp: 'boxShadowOnHover',
  properties: ['boxShadow'],
  getRules: function getRules(value, theme) {
    if (value) {
      return {
        transition: 'box-shadow 250ms linear',
        '&:hover': {
          boxShadow: getBoxShadowValue(value, theme)
        }
      };
    }
  }
}];
export default createStyleFunction(borderPropsDef);